module.exports = __webpack_public_path__ + "static/media/mt-icone-encart-3.854d7c02.svg";